import * as types from './types';
import Vue from 'vue';

export default {

    [types.SYNC]: (state, { userProperties }) => {
        state.userProperties = userProperties;
    },

    [types.SET_PROPERTIES_DATA]: (state, { tenantProperties, conversationProperties }) => {
        state.tenantProperties = tenantProperties;
        //external purpose
        conversationProperties.push({
            groupName: 'Conversation Data',
            propertyName: 'customerMessageForExternalHelpdesk',
            displayName: 'Your message',
            type: "multiline",
            required: true,
            value: '',
            placeholder: false,
        })
        state.conversationProperties = conversationProperties;
    },

    [types.FETCH_AGENT]: (state, agentList) => {
        state.agentList = agentList;
    },
    

    [types.SET_SELCTED_CONVERSATION]: (state, conversation) => {
        state.selectedConversation = conversation;
    },

    [types.SET_TEAM_DETAILS]: (state, { teams, teamsAndUsers }) => {
        state.teams = teams;
        state.teamsAndUsers = teamsAndUsers;
    },

    [types.SET_ACTIVE_AGENTS]: (state, activeAgents) => {
        state.activeAgents = activeAgents;
    },
    [types.SET_USER_PROPERTIES]: (state, { userProperties }) => {
        state.userProperties = userProperties;
    },
    [types.SET_AGENT_PROPERTIES]: (state, { isChatAccess, agentId} ) => {
        const { agentList } = state;
        Vue.set(agentList[agentId], 'isChatAccess', isChatAccess)
        Vue.set(agentList, agentId, agentList[agentId])
    },

    [types.FETCH_SCENARIOS]: (state, scenarioList) => {
        state.scenarioList = scenarioList;
    },

    [types.SET_ORDERS]: (state,  data) => {
        const {
            addMoreOrders,
            ordersData,
        } = data;
        if(addMoreOrders)
            state.orders = [ ...state.orders, ...ordersData];
        else {
            state.orders = [ ...ordersData ]
        }
    },

    [types.RESET_ORDERS_DATA]: (state) => {
        state.orders = [];
    },

    [types.SET_PERSON_ID]: (state,personId) => {
        state.personId = personId;
    },

    [types.SET_CUSTOMER_PROPERTIES]: (state, customerProperties) => {
        state.customerProperties = customerProperties;
    },
    [types.SET_SCENARIO_PRECHAT_PROPERTIES] : (state, { scenarioConversationProperties, scenarioPeopleProperties }) => {
        state.scenarioPeopleProperties = scenarioPeopleProperties;
        state.scenarioConversationProperties = scenarioConversationProperties;
    },

    [types.SET_ERRORS]: (state, { storeName, actionName, errorMessage }) => {
        if(state[storeName]) {
            state[storeName]['meta']['errors'][actionName] = errorMessage;
            state[storeName] = state[storeName]
        }
    },

    [types.SET_LOADING]: (state, { storeName, actionName, loadingStatus }) => {
        if(state[storeName]) {
            state[storeName]['meta']['loaders'][actionName] = loadingStatus;
            state[storeName] = state[storeName]
        }
    },

    [types.SET_ORDER_SHIPMENT_DETAILS]: (state, orderShipmentMap) => {
        state.orderShipmentMap = orderShipmentMap
    }

}
